// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor[data-v-c5a415fe] .w-e-text-container{z-index:1!important}.editor[data-v-c5a415fe] .w-e-toolbar{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.editor[data-v-c5a415fe] .w-e-menu{z-index:auto!important}.editor[data-v-c5a415fe] .w-e-droplist{z-index:3!important}", ""]);
// Exports
module.exports = exports;
